@let image = picture();

@if (image) {
  <img [alt]="name()" [src]="image" data-testid="avatar-image" />
} @else {
  <span data-testid="initials">{{ initials() }}</span>
}
